import {
  LocalCart,
  LocalOffer,
  LocalOrder,
  LocalSession,
} from '@lib/types/local';

import {
  LocalCartDTO,
  LocalOfferDTO,
  LocalOrderDTO,
  LocalSessionDTO,
} from './types';

export const toSession = (dto: LocalSessionDTO): LocalSession => ({
  id: dto.id,
  storeName: dto.storeName,
  storeSlug: dto.storeSlug,
  createdAt: dto.createdAt,
  active: dto.active,
  expiresAt: dto.expiresAt,
});
export const toOffer = (dto: LocalOfferDTO): LocalOffer => ({
  id: dto.id,
  name: dto.name,
  code: dto.code,
  rarity: dto.rarity,
  rarityShortName: dto.rarityShortName,
  language: dto.language,
  condition: dto.condition,
  quantity: dto.quantity,
  unitPriceCents: dto.unitPriceCents,
  imageUrl: dto.imageUrl,
});
export const toOrder = (dto: LocalOrderDTO): LocalOrder => ({
  id: dto.id,
  state: dto.state,
  totalCents: dto.totalCents,
  approvalExpiresAt: dto.approvalExpiresAt,
  paymentExpiresAt: dto.paymentExpiresAt,
  pixCopyPaste: dto.pixCopyPaste,
  pixQrCodeUrl: dto.pixQrCodeUrl,
  items: dto.items.map((item) => ({
    id: item.id,
    imageUrl: item.imageUrl,
    edition: item.edition,
    name: item.name,
    code: item.code,
    rarity: item.rarity,
    language: item.language,
    condition: item.condition,
    quantity: item.quantity,
    unitPriceCents: item.unitPriceCents,
  })),
});
export const toCart = (dto: LocalCartDTO): LocalCart => ({
  id: dto.id,
  totalCents: dto.totalCents,
  order: dto.order ? toOrder(dto.order) : undefined,
  items: dto.items.map((item) => ({
    offer: toOffer(item.offer),
    available: item.available,
    quantity: item.quantity,
  })),
});
